const HEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;
const RGBA = /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d*(?:\.\d+)?)\s*)?\)$/i;
const HEX_RADIX = 16;
const FULL_OPACITY = 100;

/** A #rgb / #rrggbb colour as lower-case #rrggbb; anything else (a name, rgba, transparent) gives `fallback`. */
export const normalizeHex = (color, fallback) => {
    if (typeof color !== 'string' || !HEX.test(color)) return fallback;
    const hex = color.slice(1).toLowerCase();
    return `#${hex.length === 3 ? hex.replace(/./g, '$&$&') : hex}`;
};

const toHexPair = (channel) => Number(channel).toString(HEX_RADIX).padStart(2, '0');

/**
 * A saved fill (`data.nodeBg`, any CSS colour per the data contract) as `{ hex, alpha }` with alpha in percent:
 * hex colours at 100 %, rgb() / rgba() with their own alpha. Anything else (a name, `transparent`) gives null.
 */
export const parseFill = (color) => {
    const hex = normalizeHex(color, null);
    if (hex) return { hex, alpha: FULL_OPACITY };
    const match = typeof color === 'string' ? RGBA.exec(color.trim()) : null;
    if (!match) return null;
    const [, r, g, b, a] = match;
    return {
        hex: `#${[r, g, b].map(toHexPair).join('')}`,
        alpha: a === undefined || a === '' ? FULL_OPACITY : Math.round(Number(a) * FULL_OPACITY),
    };
};

/** The fill to save: the hex itself when opaque, `rgba(r, g, b, a)` below 100 %. */
export const toFillColor = (hex, alpha) => {
    if (alpha >= FULL_OPACITY) return hex;
    const [r, g, b] = [1, 3, 5].map((start) => parseInt(hex.slice(start, start + 2), HEX_RADIX));
    return `rgba(${r}, ${g}, ${b}, ${alpha / FULL_OPACITY})`;
};
